export default __webpack_public_path__ + "static/media/101.70e1c71e.gif";